import { Component, OnInit, Inject } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';
import { HttpInProgressService } from '~Services/http-in-progress.service';

/**
 * Composant loader
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent extends BaseComponent implements OnInit {
    
    chargementEnCours: boolean = false;
    afficherLoader: boolean = false;

    timeount;
    chargement = 0;

    /**
     * Constructeur
     * @param httpInProgressService
     */
    constructor(@Inject(HttpInProgressService) private httpInProgressService: HttpInProgressService) {
        super();
        httpInProgressService.listerRequetesEnCours().subscribe((liste: any[]) => {
            let loading = liste.length > 0;

            if (this.chargementEnCours && !loading) {
                this.chargement = 100;

                clearTimeout(this.timeount);
                this.timeount = setTimeout(() => {
                    this.afficherLoader = false;
                }, 500);
            }

            if (!this.chargementEnCours && loading) {
                clearTimeout(this.timeount);

                this.chargement = 1;
                this.afficherLoader = true;

                this.timeount = setTimeout(() => {
                    this.chargement = 50;
                }, 1);
            }

            this.chargementEnCours = loading;
        });
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
